const standardTypes = {
  GET_STANDARD_QUIZSET_REQUEST: "STANDARD/GET_QUIZSET_REQUEST",
  GET_STANDARD_QUIZSET_SUCCESS: "STANDARD/GET_QUIZSET_SUCCESS",
  GET_STANDARD_QUIZSET_FAILURE: "STANDARD/GET_QUIZSET_FAILURE",

  GET_STANDARD_CODE_REQUEST: "STANDARD/GET_CODE_REQUEST",
  GET_STANDARD_CODE_SUCCESS: "STANDARD/GET_CODE_SUCCESS",
  GET_STANDARD_CODE_FAILURE: "STANDARD/GET_CODE_FAILURE",

  GET_STANDARD_REVIEWERS_REQUEST: "STANDARD/GET_REVIEWERS_REQUEST",
  GET_STANDARD_REVIEWERS_SUCCESS: "STANDARD/GET_REVIEWERS_SUCCESS",
  GET_STANDARD_REVIEWERS_FAILURE: "STANDARD/GET_REVIEWERS_FAILURE",

  GET_STANDARD_CREATORS_REQUEST: "STANDARD/GET_CREATORS_REQUEST",
  GET_STANDARD_CREATORS_SUCCESS: "STANDARD/GET_CREATORS_SUCCESS",
  GET_STANDARD_CREATORS_FAILURE: "STANDARD/GET_CREATORS_FAILURE",
};

export default standardTypes;
